/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'thumbs-up-active': {
    width: 18,
    height: 17,
    viewBox: '0 0 18 17',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M7.447.588A1 1 0 0 1 8.36 0c.866 0 1.7.339 2.318.946.618.608.968 1.437.968 2.304v2h3.309a2.545 2.545 0 0 1 1.921.853 2.493 2.493 0 0 1 .596 2.024l-1.052 6.75v.001a2.494 2.494 0 0 1-.866 1.532 2.54 2.54 0 0 1-1.651.59H3.024c-.664 0-1.304-.26-1.779-.727A2.488 2.488 0 0 1 .5 14.5V9.25c0-.668.27-1.306.745-1.773a2.537 2.537 0 0 1 1.78-.727h1.64L7.447.588ZM4.31 15V8.75H3.024a.537.537 0 0 0-.376.152.488.488 0 0 0-.148.348v5.25c0 .127.051.253.148.348a.537.537 0 0 0 .376.152H4.31Z" _fill="#4990E2"/>'
  }
})
